<template>
  <q-scroll-area style="height: calc(100vh - 420px) !important">
    <div v-if="gridData.length > 0" class="q-px-md">
      <table
        class="q-pa-sm q-my-sm full-width text-left"
        style="border: 1px solid black"
        v-for="(event, index) in gridData"
        :key="`event_${index}`"
      >
        <tr>
          <th>{{ event.event_no }} / {{ event.name }}</th>
          <th
            width="100px"
            v-for="(round, roundIndex) in event.rounds"
            :key="`roundHeader_${roundIndex}`"
          >
            {{ round.round_name }}
          </th>
          <th width="100px">Total Points</th>
          <!-- <th width="100px">Placing</th> -->
        </tr>
        <tr
          v-for="(pointsValue, pointsValueIndex) in event.pointsValues"
          :key="`pointsValue_${pointsValueIndex}`"
        >
          <td>{{ pointsValue[0].team_name }}</td>
          <td
            v-for="(roundValue, roundValueIndex) in pointsValue"
            :key="`roundValue_${roundValueIndex}`"
          >
            {{ roundValue.points }}
          </td>
          <!-- <td>0</td> -->
        </tr>
      </table>
    </div>
  </q-scroll-area>
</template>

<script>
  import datatable from "@/components/datatable/datatable.vue";

  export default {
    props: {
      gridData: [],
      search: {
        default: "",
        type: String,
      },
    },
    components: {
      datatable,
    },
    data() {
      return {};
    },
    methods: {
      handleDoubleClick(row) {
        console.log(row);
      },
    },
  };
</script>

<style>
</style>template
